import axios from 'axios'
import  { checkErrorData } from './authAction'
import  { formatList, capitalize, capitalizeWord, orderByAsc, orderByDsc } from './format'

export function newSalary(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_SALARY_START", payload: "" })

            console.log("new Salary START", {data})
            const res = await axios.post('/salaries/new',{data})
            console.log({res});            
                        
            if (checkErrorData(res, "CREATE_SALARY_ERROR", dispatch ) ) {
				dispatch({ type: "NEW_SALARY", payload: res.data })
				dispatch({ type: "CREATE_SALARY_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] new salary ", err);
            dispatch({
                type: "CREATE_SALARY_ERROR",
                payload: err
            })
        }
    }
}

export function fetchSalaries() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_SALARIES_START", payload: "" })

            console.log("fetch Salary START")
            const res = await axios.get('/salaries/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_SALARIES_ERROR", dispatch ) ) { 
                dispatch({
                    type: "GET_SALARIES",
                    payload: formatList(orderByDsc(res.data, "salary_date"), "salary_id")
                })
                dispatch({ type: "FETCH_SALARIES_FULFILLED", payload: "" })

            } 
        } catch(err) {
            console.log("[ERROR] get salaries list ", err);
            dispatch({ type: "FETCH_SALARIES_ERROR", payload: err })
        }
    }
}
export function fetchEmployeeSalaries() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_SALARIES_START", payload: "" })

            console.log("fetch Salary START")
            const res = await axios.get('/employees/salaries/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_SALARIES_ERROR", dispatch ) ) { 
                dispatch({
                    type: "GET_SALARIES",
                    payload: formatList(orderByDsc(res.data, "salary_date"), "salary_id")
                })
                dispatch({ type: "FETCH_SALARIES_FULFILLED", payload: "" })

            } 
        } catch(err) {
            console.log("[ERROR] get salaries list ", err);
            dispatch({ type: "FETCH_SALARIES_ERROR", payload: err })
        }
    }
}
export function fetchUserSalaries(employee_id) {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_SALARIES_START", payload: "" })

            console.log("fetch Salary START")
            const res = await axios.post('/users/salaries/get/all', {data: employee_id})
            console.log({res});
            
            if (checkErrorData(res, "FETCH_SALARIES_ERROR", dispatch ) ) { 
                // dispatch({
                //     type: "GET_SALARIES",
                //     payload: formatList(res.data, "salary_id")
                // })
                dispatch({ type: "FETCH_SALARIES_FULFILLED", payload: "" })
                return formatList(orderByDsc(res.data, "salary_date"), "salary_id")
            } 
            
        } catch(err) {
            console.log("[ERROR] get salaries list ", err);
            dispatch({ type: "FETCH_SALARIES_ERROR", payload: err })
        }
    }
}

export function updateSalary(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_SALARY_START", payload: "" })

            console.log("update Salary START")
            const res = await axios.post("/salaries/update", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_SALARY_ERROR", dispatch ) ) { 
                // dispatch(refetchSalaries())
                dispatch({ type: "UPDATE_SALARY_FULFILLED", payload: "" })
            }
        } catch(err) {
            console.log("[ERROR] update salary ", err);
            dispatch({
                type: "UPDATE_SALARY_ERROR",
                payload: err
                
            })
        }
    }
}
export function deleteSalary(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "DELETE_SALARY_START", payload: "" })

            console.log("delete Salary START")
            const res = await axios.post("/salaries/delete", {data: data.salary_id})
            console.log({res});
            
            if (checkErrorData(res, "DELETE_SALARY_ERROR", dispatch ) ) { 
                dispatch({
                    type: "DELETE_SALARY",
                    payload: data.salary_id
                })
                dispatch({ type: "DELETE_SALARY_FULFILLED", payload: "" })
            }
        } catch(err) {
            console.log("[ERROR] delete salary ", err);
            dispatch({
                type: "DELETE_SALARY_ERROR",
                payload: err
                
            })
        }
    }
}

export function fetchCharges() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_CHARGES_START", payload: "" })

            console.log("fetch Charges START")
            const res = await axios.get('/charges/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_CHARGES_ERROR", dispatch ) ) { 
                dispatch({
                    type: "GET_CHARGES",
                    payload: formatList(orderByDsc(res.data, "salary_line_date"), "salary_line_id")
                })
                dispatch({ type: "FETCH_CHARGES_FULFILLED", payload: "" })

            } 
        } catch(err) {
            console.log("[ERROR] get charges list ", err);
            dispatch({ type: "FETCH_CHARGES_ERROR", payload: err })
        }
    }
}
export function updateFetchCharge(itemID) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_FETCH_CHARGE_START", payload: "" })

            console.log("update Charge START")
            const res = await axios.post("/salaries/charges/single", {chargeID: itemID})
            console.log({res});
            
            if(checkErrorData(res, "UPDATE_FETCH_CHARGE_ERROR", dispatch ) ) {
                dispatch({
                    type: "UPDATE_FETCH_CHARGE",
                    payload: res.data
                })
                dispatch({ type: "UPDATE_FETCH_CHARGE_FULFILLED", payload: "" })
            }

        } catch(err) {
            console.log("[ERROR] update spending ", err);
            dispatch({
                type: "UPDATE_FETCH_CHARGE_ERROR",
                payload: err
                
            })
        }
    }
}
export function updateFetchSalary(itemID) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_FETCH_SALARY_START", payload: "" })

            console.log("update Salary START")
            const res = await axios.post("/salaries/single", {salaryID: itemID})
            console.log({res});
            
            if(checkErrorData(res, "UPDATE_FETCH_SALARY_ERROR", dispatch ) ) {
                dispatch({
                    type: "UPDATE_FETCH_SALARY",
                    payload: res.data
                })
                dispatch({ type: "UPDATE_FETCH_SALARY_FULFILLED", payload: "" })
            }

        } catch(err) {
            console.log("[ERROR] update spending ", err);
            dispatch({
                type: "UPDATE_FETCH_SALARY_ERROR",
                payload: err
                
            })
        }
    }
}